(function () {
  function getHandles(container) {
    var raw =
      container.getAttribute('data-product-handles') ||
      container.getAttribute('data-products') ||
      container.getAttribute('data-product') ||
      '';
    return raw
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
  }

  function handleFromProductUrl(url) {
    try {
      var path = url.indexOf('/') === 0 ? url : new URL(url, window.location.origin).pathname;
      var parts = path.split('/').filter(Boolean);
      return parts[parts.length - 1] || '';
    } catch (e) {
      return '';
    }
  }

  function stripDuplicateAssetScripts(root) {
    root.querySelectorAll('script[src]').forEach(function (script) {
      script.remove();
    });
  }

  function shouldSkipInlineScript(code) {
    return (
      code.indexOf('product-fixed-atc') !== -1 ||
      code.indexOf('sticky_ATC') !== -1 ||
      code.indexOf('sticky-atc') !== -1 ||
      code.indexOf('initProductTabs') !== -1 ||
      code.indexOf('__fauxSwatchInit') !== -1
    );
  }

  function runInlineScripts(scope) {
    scope.querySelectorAll('script:not([src])').forEach(function (oldScript) {
      var code = oldScript.textContent || '';
      if (shouldSkipInlineScript(code)) {
        oldScript.remove();
        return;
      }
      var script = document.createElement('script');
      script.textContent = code;
      oldScript.replaceWith(script);
    });
  }

  function stripBlogExtras(root) {
    var removeSelectors = [
      '.complementary-products',
      'product-recommendations',
      '.product-fixed-atc-wrapper',
      '[data-rebuy-id]',
      'tolstoy-stories',
      '.tolstoy-stories-wrapper',
      '.pet-port-recommand',
    ];

    removeSelectors.forEach(function (selector) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.remove();
      });
    });
  }

  /** Unique IDs per embed so 2+ products do not clash (modals, accordions). */
  function namespaceEmbedIds(root, handle) {
    var suffix = 'blog-' + String(handle).replace(/[^a-z0-9-]/gi, '-');
    var idMap = {};

    root.querySelectorAll('[id]').forEach(function (el) {
      var oldId = el.id;
      if (!oldId) return;
      var newId = oldId + '--' + suffix;
      idMap[oldId] = newId;
      el.id = newId;
    });

    root.querySelectorAll('[data-modal]').forEach(function (el) {
      var modalId = el.getAttribute('data-modal');
      if (modalId && idMap[modalId]) {
        el.setAttribute('data-modal', idMap[modalId]);
      }
    });

    root.querySelectorAll('[aria-controls]').forEach(function (el) {
      var controls = el.getAttribute('aria-controls');
      if (controls && idMap[controls]) {
        el.setAttribute('aria-controls', idMap[controls]);
      }
    });
  }

  function initProductTabsInScope(root) {
    root.querySelectorAll('.product-tabs').forEach(function (tabsWrapper) {
      if (tabsWrapper.dataset.blogTabsInit === 'true') return;
      tabsWrapper.dataset.blogTabsInit = 'true';

      var containers = tabsWrapper.querySelectorAll('.product-tab-container');

      containers.forEach(function (item) {
        var content = item.querySelector('.product-tab-content');
        if (!content) return;
        content.style.maxHeight = null;
        item.classList.remove('open');
      });

      if (tabsWrapper.getAttribute('data-open-first-tab') === 'true') {
        var firstContainer = containers[0];
        if (firstContainer) {
          var firstContent = firstContainer.querySelector('.product-tab-content');
          if (firstContent) {
            firstContainer.classList.add('open');
            firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
          }
        }
      }

      tabsWrapper.querySelectorAll('.product-tab-heading').forEach(function (heading) {
        heading.addEventListener('click', function () {
          var parent = this.closest('.product-tab-container');
          var content = parent && parent.querySelector('.product-tab-content');
          if (!content) return;

          tabsWrapper.querySelectorAll('.product-tab-container.open').forEach(function (openTab) {
            if (openTab === parent) return;
            var openContent = openTab.querySelector('.product-tab-content');
            if (openContent) {
              openContent.style.maxHeight = openContent.scrollHeight + 'px';
              setTimeout(function () {
                openContent.style.maxHeight = '0px';
              }, 10);
            }
            openTab.classList.remove('open');
          });

          if (parent.classList.contains('open')) {
            content.style.maxHeight = content.scrollHeight + 'px';
            setTimeout(function () {
              content.style.maxHeight = '0px';
            }, 10);
            parent.classList.remove('open');
          } else {
            parent.classList.add('open');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      });
    });
  }

  function initDescriptionPopupsInScope(root) {
    root.querySelectorAll('.js-product-description-popup').forEach(function (link) {
      if (link.dataset.blogPopupInit === 'true') return;
      link.dataset.blogPopupInit = 'true';

      link.addEventListener('click', function (e) {
        e.preventDefault();
        var modalId = link.getAttribute('data-modal');
        if (!modalId) return;
        var modal = root.querySelector('#' + CSS.escape(modalId));
        if (modal && typeof modal.show === 'function') {
          modal.show(link);
        }
      });
    });
  }

  function initFauxSwatchHoverInScope(root) {
    root.querySelectorAll('.faux-swatch-wrapper').forEach(function (swatchWrapper) {
      if (swatchWrapper.dataset.fauxSwatchHoverBound === '1') return;
      swatchWrapper.dataset.fauxSwatchHoverBound = '1';

      var activeColorName = swatchWrapper.querySelector('.js-faux-color-swatch-active-color-name');
      if (!activeColorName) return;

      var defaultColor =
        activeColorName.getAttribute('data-default-color') || activeColorName.textContent.trim();

      swatchWrapper.querySelectorAll('.faux-swatch-item').forEach(function (swatchItem) {
        var swatchColor = swatchItem.getAttribute('data-swatch-color');
        if (!swatchColor) return;
        swatchItem.addEventListener('mouseenter', function () {
          activeColorName.textContent = swatchColor.trim();
        });
        swatchItem.addEventListener('mouseleave', function () {
          activeColorName.textContent = defaultColor.trim();
        });
      });
    });
  }

  function initFauxSwatchClicksInScope(root, currentHandle, reloadProduct) {
    root.querySelectorAll('.faux-swatch-wrapper .js-faux-swatch-link').forEach(function (link) {
      if (link.dataset.blogSwatchClickInit === 'true') return;
      link.dataset.blogSwatchClickInit = 'true';

      link.addEventListener('click', function (e) {
        var productUrl = (link.getAttribute('data-product-url') || link.getAttribute('href') || '').split('?')[0];
        if (!productUrl) return;

        var newHandle = handleFromProductUrl(productUrl);
        if (!newHandle || newHandle === currentHandle) return;

        e.preventDefault();
        var item = root.closest('.blog-products__item');
        if (item && typeof reloadProduct === 'function') {
          reloadProduct(item, newHandle);
        }
      });
    });
  }

  function initBlogEmbedInteractions(root, handle, reloadProduct) {
    initProductTabsInScope(root);
    initDescriptionPopupsInScope(root);
    initFauxSwatchHoverInScope(root);
    initFauxSwatchClicksInScope(root, handle, reloadProduct);
  }

  function prepareEmbed(root, handle, reloadProduct) {
    stripBlogExtras(root);

    root.querySelectorAll('product-info').forEach(function (el) {
      el.setAttribute('data-update-url', 'false');
    });

    root.querySelectorAll('.scroll-trigger').forEach(function (el) {
      el.classList.add('scroll-trigger--cancel');
    });

    document.body.classList.remove('sticky_ATC-btn');
    document.body.style.removeProperty('--sticky-atc-height');
    document.body.style.removeProperty('padding-bottom');

    if (typeof customElements !== 'undefined') {
      root.querySelectorAll('product-info, media-gallery, slider-component, product-form, modal-dialog').forEach(
        function (el) {
          customElements.upgrade(el);
        }
      );
    }

    runInlineScripts(root);
    initBlogEmbedInteractions(root, handle, reloadProduct);
  }

  function parseProductHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var productInfo = doc.querySelector('product-info');

    if (productInfo) {
      return productInfo.outerHTML;
    }

    return null;
  }

  function mountProductHtml(item, html, handle) {
    if (!html) {
      throw new Error('empty product html');
    }

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var root = doc.querySelector('product-info') || doc.body.firstElementChild;

    if (!root) {
      throw new Error('empty product root');
    }

    stripDuplicateAssetScripts(root);

    var wrap = document.createElement('div');
    wrap.className = 'blog-products__embed';
    wrap.appendChild(document.importNode(root, true));
    namespaceEmbedIds(wrap, handle);
    item.innerHTML = '';
    item.appendChild(wrap);
    prepareEmbed(wrap, handle, loadProduct);
  }

  function fetchProductPage(handle) {
    return fetch('/products/' + encodeURIComponent(handle)).then(function (res) {
      if (!res.ok) throw new Error('product page ' + res.status);
      return res.text();
    });
  }

  function fetchBlogEmbedView(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=blog-embed').then(function (res) {
      if (!res.ok) throw new Error('blog-embed ' + res.status);
      return res.text();
    });
  }

  function fetchProductHtml(handle) {
    return fetchProductPage(handle)
      .then(parseProductHtml)
      .then(function (html) {
        if (html) return html;
        throw new Error('no product-info on page');
      })
      .catch(function () {
        return fetchBlogEmbedView(handle);
      });
  }

  function loadProduct(item, handle) {
    return fetchProductHtml(handle)
      .then(function (html) {
        mountProductHtml(item, html, handle);
        item.setAttribute('data-product-handle', handle);
      })
      .catch(function () {
        item.innerHTML =
          '<p class="blog-products__error">Could not load product: ' +
          handle +
          '. Check the handle matches the product URL.</p>';
      });
  }

  function init() {
    document.querySelectorAll('.blog-products').forEach(function (el) {
      if (el.querySelector('.blog-products__embed') && !el.querySelector('.blog-products__error')) return;

      var handles = getHandles(el);
      if (!handles.length) return;

      el.classList.remove('blog-products--ready');
      el.classList.add('blog-products--loading');

      Promise.all(
        handles.map(function (handle) {
          var item = document.createElement('div');
          item.className = 'blog-products__item';
          item.setAttribute('data-product-handle', handle);
          el.appendChild(item);
          return loadProduct(item, handle);
        })
      ).finally(function () {
        el.classList.remove('blog-products--loading');
        el.classList.add('blog-products--ready');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
